import { Message, UserData } from '@/types'
import { useEffect, useRef } from 'react'
import useAuthUser from 'react-auth-kit/hooks/useAuthUser'
import { markMessageAsSeen } from '../store/messages/messages.actions'

const useMessageObserver = (
  message: Message,
  root: HTMLElement | null,
  threshold = 0.1
) => {
  const messageRef = useRef(null)
  const user = useAuthUser<UserData>()

  useEffect(() => {
    if (!root) {
      return
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            user?.user_id !== message.sender_id &&
            message.id
          ) {
            markMessageAsSeen(message.id)
            observer.unobserve(entry.target)
          }
        })
      },
      {
        root: root,
        threshold: threshold,
      }
    )

    const refCopy = messageRef.current
    if (refCopy) {
      observer.observe(refCopy)
    }

    return () => {
      if (refCopy) {
        observer.unobserve(refCopy)
        observer.disconnect()
      }
    }
  }, [message, root, threshold, user?.user_id])

  return messageRef
}

export default useMessageObserver
